import { useConfigStore } from '@/Stores/config';
import { useContextStore } from '@/Stores/context';
import { ConsentOrchestrator } from '@/Integrations/Consent/consentOrchestrator';
import { buildConsentAwareTools } from '@/Integrations/Tools/toolRegistry';
import {
  getActiveConsentManagementInfo,
  getConsentProvider,
} from '@/Integrations/Consent/consentService';

let activeOrchestrator: ConsentOrchestrator | null = null;

export async function initStandaloneIntegrations(): Promise<void> {
  const contextStore = useContextStore();
  if (contextStore.isWcIntegration) {
    return;
  }

  const configStore = useConfigStore();
  if (!configStore || typeof configStore === 'string' || !configStore.config) {
    return;
  }

  const tools = buildConsentAwareTools(configStore.config);
  if (!tools.length && !getActiveConsentManagementInfo()) {
    return;
  }

  activeOrchestrator?.stop();
  activeOrchestrator = new ConsentOrchestrator(getConsentProvider(), tools);
  activeOrchestrator.start().catch((error) => {
    console.error('[Consent] Failed to initialize standalone integrations', error);
  });
}
